import { BaseField } from "./base";

export class RangeField extends BaseField {
	constructor(field, form) {
		super(field, form);
	}

	init() {
		// Set the input type to range and initialize value from field's current setting
		this.field.type = "range";
		this.value = this.field.value; // initial value from backend

		// Check if the range should display its current value
		if (this.field.dataset.showValue === "true") {
			this.valueDisplay = document.createElement("span");
			this.valueDisplay.className = "range-value-display";
			this.valueDisplay.style.marginLeft = "10px";
			this.valueDisplay.textContent = this.value;
			this.field.parentNode.insertBefore(
				this.valueDisplay,
				this.field.nextSibling,
			);
		}

		// Update value on input changes
		this.field.addEventListener("input", () => {
			this.value = this.field.value;
			if (this.valueDisplay) {
				this.valueDisplay.textContent = this.value;
			}
		});
	}
}
